"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkCircle = exports.checkCircle = { "viewBox": "0 0 1536 1792", "children": [{ "name": "path", "attribs": { "d": "M1284 734q0-28-18-46l-91-90q-19-19-45-19t-45 19l-408 407-226-226q-19-19-45-19t-45 19l-91 90q-18 18-18 46 0 27 18 45l362 362q19 19 45 19 27 0 46-19l543-543q18-18 18-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/fa/checkCircle.js
// module id = 768
// module chunks = 1